import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {SortingComponent} from '../sorting.component';
import {Router, RouterLink} from '@angular/router';
import {CordovaService} from '../cordova.service';
import {LocalStorage} from '../storage.class';
import {User} from '../classes/user.class';
import {CurrencyPipe, DatePipe, formatDate} from '@angular/common';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {DeclarationStatus} from '../declaration-status';
import {DeclarationService} from '../services/declaration.service';
import {Declaration} from '../declaration';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {HasFeaturePipe} from "../pipes/has-feature.pipe";
import {SortingIconComponent} from "../sorting-icon.component";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-declaration-request',
    templateUrl: './declaration-request.component.html',
    styleUrls: ['./declaration-request.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatButton,
        MatFormField,
        MatSelect,
        FormsModule,
        MatOption,
        HasFeaturePipe,
        SortingIconComponent,
        MatRipple,
        CurrencyPipe,
        DatePipe,
        MatIconButton
    ]
})
export class DeclarationRequestComponent extends SortingComponent<Declaration> implements OnInit, OnDestroy {

    readonly user = signal<User>(null);
    readonly statusIds = signal<number[]>([1, 2]);
    readonly statusList = signal<DeclarationStatus[]>([]);
    readonly showStatusFilter = signal<boolean>(true);

    constructor(
        private router: Router,
        private cordovaService: CordovaService,
        private confirmDialog: ConfirmDialogService,
        private declarationService: DeclarationService
    ) {
        super();
    }

    ngOnInit(): void {
        this.currentSort.update(() => 'created_at');
        this.desc.update(() => true);

        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        if (!AuthorisationService.hasFeature('declarationManagement')) {
            this.statusIds.set([1, 2, 3, 4]);
            this.showStatusFilter.set(false);
        }
        this.getData();
        this.user.set(LocalStorage.getUser());
        this.subscriptions.add(this.declarationService.statusList().subscribe(status => {
            this.statusList.set(status.data);
        }));
    }

    public getData() {
        this.subscriptions.add(
            this.declarationService.listRequests(this.statusIds()).subscribe(requests => {
                this.list.set(requests.data);
            })
        );
    }

    delete(event, declaration: Declaration) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u deze aanvraag aangemaakt op ${formatDate(declaration.created_at, 'd MMM yyyy, H:mm', 'nl')} wilt intrekken?`,
            'Intrekken',
            'Behouden'
        ).then(() => {
            this.declarationService.deleteRequest(declaration.id).subscribe(() => {
                const index = this.list().indexOf(declaration);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
